import { IPayType, IPayTypeTotal, IPayrollPunchSet, IExpensesPayrollData, IPunchSetDocument, ITimecardPunchSet } from "../models"
import * as timeHelper from "./timeHelper"
import * as utils from "./utils"

export function getInitPayTypeTotal(): IPayTypeTotal {
    return {
        PayTypeId: null,
        PayTypeName: null,
        PayTypeCode: null,
        TotalHours: 0,
        TotalMinutes: 0,
        TotalRegHours: 0,
        TotalRegMinutes: 0,
        TotalOTHours: 0,
        TotalOTMinutes: 0,
        TotalOT2Hours: 0,
        TotalOT2Minutes: 0,
        TotalAmount: 0,
        TotalRegPay: 0,
        TotalOTPay: 0,
        TotalOT2Pay: 0,
        TotalPay: 0,
        TotalBill: 0,
        Paid: false,
        Overtime: false
    }
}

export function getPayTypeTotal(payType: IPayType, ps: IPayrollPunchSet | IPunchSetDocument | ITimecardPunchSet) {
    const payTypeTotal = getInitPayTypeTotal()
    payTypeTotal.PayTypeId = payType.Id
    payTypeTotal.PayTypeName = payType.Name
    payTypeTotal.PayTypeCode = getPayTypeCodeDefault(payType.Code, payType.Name)
    payTypeTotal.TotalHours = ps.RoundingRuleId ? ps.RoundedHours : ps.Hours
    payTypeTotal.TotalMinutes = timeHelper.convertToMinute(payTypeTotal.TotalHours)
    payTypeTotal.TotalRegHours = ps.RegHours
    payTypeTotal.TotalRegMinutes = timeHelper.convertToMinute(payTypeTotal.TotalRegHours)
    payTypeTotal.TotalOTHours = ps.OTHours
    payTypeTotal.TotalOTMinutes = timeHelper.convertToMinute(payTypeTotal.TotalOTHours)
    payTypeTotal.TotalOT2Hours = ps.OT2Hours
    payTypeTotal.TotalOT2Minutes = timeHelper.convertToMinute(payTypeTotal.TotalOT2Hours)
    payTypeTotal.TotalAmount = 0
    payTypeTotal.TotalRegPay = ps.PayTotalRegularTime
    payTypeTotal.TotalOTPay = ps.PayTotalOvertime
    payTypeTotal.TotalOT2Pay = ps.PayTotalDoubleOvertime
    payTypeTotal.TotalPay = ps.PayTotal
    payTypeTotal.TotalBill = ps.BillTotal
    payTypeTotal.Paid = payType.PaidTime
    payTypeTotal.Overtime = payType.UseTowardsOvertime
    return payTypeTotal
}

export function getPayTypeTotalByExpense(payType: IPayType, expense: IExpensesPayrollData): IPayTypeTotal {
    const payTypeTotal = getInitPayTypeTotal()
    payTypeTotal.PayTypeId = payType.Id
    payTypeTotal.PayTypeName = payType.Name
    payTypeTotal.PayTypeCode = getPayTypeCodeDefault(payType.Code, payType.Name)
    payTypeTotal.TotalMinutes = expense.IsTime ? timeHelper.convertToMinute(utils.roundToTwo(expense.Amount)) : 0
    payTypeTotal.TotalHours = expense.IsTime ? utils.roundToTwo(expense.Amount) : 0
    payTypeTotal.TotalRegMinutes = expense.IsTime && expense.TimeDurations != null ? expense.TimeDurations.RegularDurationInMinutes : 0
    payTypeTotal.TotalRegHours = expense.IsTime && expense.TimeDurations != null ? expense.TimeDurations.RegularDurationInHours : 0
    payTypeTotal.TotalOTMinutes = expense.IsTime && expense.TimeDurations != null ? expense.TimeDurations.OTDurationInMinutes : 0
    payTypeTotal.TotalOTHours = expense.IsTime && expense.TimeDurations != null ? expense.TimeDurations.OTDurationInHours : 0
    payTypeTotal.TotalOT2Minutes = expense.IsTime && expense.TimeDurations != null ? expense.TimeDurations.OT2DurationInMinutes : 0
    payTypeTotal.TotalOT2Hours = expense.IsTime && expense.TimeDurations != null ? expense.TimeDurations.OT2DurationInHours : 0
    payTypeTotal.TotalAmount = expense.IsTime ? 0 : expense.Amount

    const payRate = expense.IsTime && expense.Classification != null ? expense.Classification.PayRate : 0
    payTypeTotal.TotalRegPay = payTypeTotal.TotalRegHours * payRate
    payTypeTotal.TotalOTPay = payTypeTotal.TotalOTHours * payRate * 1.5
    payTypeTotal.TotalOT2Pay = payTypeTotal.TotalOT2Hours * payRate * 2

    payTypeTotal.TotalPay = !expense.IsTime ? expense.Amount : expense.Classification == null ? 0 : expense.Classification.PayAmount
    payTypeTotal.TotalBill = expense.IsTime && expense.Classification != null ? expense.Classification.BillAmount : 0
    payTypeTotal.Paid = payType.PaidTime
    payTypeTotal.Overtime = payType.UseTowardsOvertime
    return payTypeTotal
}

export function getPayTypeTotals(addPayTypeTotal: IPayTypeTotal, payTypeTotals: IPayTypeTotal[]): IPayTypeTotal[] {
    var existPayTypeTotalIndex = payTypeTotals.findIndex(ptt => ptt.PayTypeId == addPayTypeTotal.PayTypeId)
    if (existPayTypeTotalIndex == -1) {
        payTypeTotals.push(getNewPayTypeTotal(addPayTypeTotal))
    }
    else {
        payTypeTotals[existPayTypeTotalIndex] = MergePayTypeTotal(payTypeTotals[existPayTypeTotalIndex], addPayTypeTotal)
    }

    return payTypeTotals
}

function getNewPayTypeTotal(payTypeTotal: IPayTypeTotal): IPayTypeTotal {
    const newPayTypeTotal = getInitPayTypeTotal()
    newPayTypeTotal.PayTypeId = payTypeTotal.PayTypeId
    newPayTypeTotal.PayTypeName = payTypeTotal.PayTypeName
    newPayTypeTotal.PayTypeCode = payTypeTotal.PayTypeCode
    newPayTypeTotal.TotalHours = payTypeTotal.TotalHours
    newPayTypeTotal.TotalMinutes = timeHelper.convertToMinute(payTypeTotal.TotalHours)
    newPayTypeTotal.TotalRegHours = payTypeTotal.TotalRegHours
    newPayTypeTotal.TotalRegMinutes = timeHelper.convertToMinute(payTypeTotal.TotalRegHours)
    newPayTypeTotal.TotalOTHours = payTypeTotal.TotalOTHours
    newPayTypeTotal.TotalOTMinutes = timeHelper.convertToMinute(payTypeTotal.TotalOTHours)
    newPayTypeTotal.TotalOT2Hours = payTypeTotal.TotalOT2Hours
    newPayTypeTotal.TotalOT2Minutes = timeHelper.convertToMinute(payTypeTotal.TotalOT2Hours)
    newPayTypeTotal.TotalAmount = payTypeTotal.TotalAmount
    newPayTypeTotal.TotalRegPay = payTypeTotal.TotalRegPay
    newPayTypeTotal.TotalOTPay = payTypeTotal.TotalOTPay
    newPayTypeTotal.TotalOT2Pay = payTypeTotal.TotalOT2Pay
    newPayTypeTotal.TotalPay = payTypeTotal.TotalPay
    newPayTypeTotal.TotalBill = payTypeTotal.TotalBill
    newPayTypeTotal.Paid = payTypeTotal.Paid
    newPayTypeTotal.Overtime = payTypeTotal.Overtime
    return newPayTypeTotal
}

function MergePayTypeTotal(payTypeTotal: IPayTypeTotal, mergePayTypeTotal: IPayTypeTotal): IPayTypeTotal {
    const returnResult = getNewPayTypeTotal(payTypeTotal)
    const other = getNewPayTypeTotal(mergePayTypeTotal)
    returnResult.TotalHours = utils.roundToTwo(payTypeTotal.TotalHours + other.TotalHours)
    returnResult.TotalMinutes = timeHelper.convertToMinute(returnResult.TotalHours)
    returnResult.TotalRegHours = utils.roundToTwo(payTypeTotal.TotalRegHours + other.TotalRegHours)
    returnResult.TotalRegMinutes = timeHelper.convertToMinute(returnResult.TotalRegHours)
    returnResult.TotalOTHours = utils.roundToTwo(payTypeTotal.TotalOTHours + other.TotalOTHours)
    returnResult.TotalOTMinutes = timeHelper.convertToMinute(returnResult.TotalOTHours)
    returnResult.TotalOT2Hours = utils.roundToTwo(payTypeTotal.TotalOT2Hours + other.TotalOT2Hours)
    returnResult.TotalOT2Minutes = timeHelper.convertToMinute(returnResult.TotalOT2Hours)
    returnResult.TotalAmount = utils.roundToTwo(payTypeTotal.TotalAmount + other.TotalAmount)
    returnResult.TotalRegPay = utils.roundToTwo(payTypeTotal.TotalRegPay + other.TotalRegPay)
    returnResult.TotalOTPay = utils.roundToTwo(payTypeTotal.TotalOTPay + other.TotalOTPay)
    returnResult.TotalOT2Pay = utils.roundToTwo(payTypeTotal.TotalOT2Pay + other.TotalOT2Pay)
    returnResult.TotalPay = utils.roundToTwo(payTypeTotal.TotalPay + other.TotalPay)
    returnResult.TotalBill = utils.roundToTwo(payTypeTotal.TotalBill + other.TotalBill)
    return returnResult
}

function getPayTypeCodeDefault(code: string, name: string): string {
    return (
        code != null && code.length > 0 ?
            code :
            name != null && name.length > 0 ?
                name.length >= 3 ?
                    name.substring(0, 3) :
                    name :
                ""
    ).toUpperCase()
}